import React, { useEffect, useState } from "react";
import { getData, postData } from "../../../../services/library";
import InputMask from "react-input-mask";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { UrlApi } from "../../../../services/apirest";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

function NuevaRendicion({ open, onClose, username }) {
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };
  const [choferes, setChoferes] = useState();
  const [hojaRuta, setHojaRuta] = useState([]);
  const [choferSeleccionado, setChoferSeleccionado] = useState("");
  const [rendicion, setRendicion] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [uuidRendicion, setUuidRendicion] = useState(uuidv4());
  const [repartoTarde, setRepartoTarde] = useState(false);
  const [datos, setDatos] = useState({
    nro_rendicion: "",
    fecha_para: moment(new Date()).format("YYYY-MM-DD"),
  });
  const [disbtn, setDisbtn] = useState(true);

  const [checked, setChecked] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [mostrarAdvertencia, setMostrarAdvertencia] = useState(false);
  const [hojaSeleccionada, setHojaSeleccionada] = useState("");
  const [nroRendicionValido, setNroRendicionValido] = useState(true);
  const [verificandoNro, setVerificandoNro] = useState(false);
  const [nroRendicionMensaje, setNroRendicionMensaje] = useState("");
  const [esExtendida, setEsExtendida] = useState(0);
  const [tieneExtendidas, setTieneExtendidas] = useState(false);
  const [verificandoExtendidas, setVerificandoExtendidas] = useState(false);

  useEffect(() => {
    getData(
      "/envasado_hoja_ruta/xsuc/" + localStorage.getItem("suc_auth").split(","),
      setHojaRuta,
    );
    getData(
      "/choferes/envasadoxsucauth/" +
        localStorage.getItem("suc_auth").split(","),
      setChoferes,
    );
  }, []);

  const obtenerRendicion = async () => {
    setDisbtn(true);
    try {
      await getData(
        "/envasado_rendiciones/choferxfecha/" +
          choferSeleccionado.id +
          "/" +
          moment(datos.fecha_para, "YYYY-MM-DD").format("YYYY-MM-DD"),
        setRendicion,
      );
    } catch (error) {
      console.error("Error al obtener rendición:", error);
    } finally {
      setDisbtn(false);
    }
  };

  const verificarRendicionesExtendidas = async (choferId) => {
    if (!choferId) return false;

    setVerificandoExtendidas(true);
    try {
      const response = await fetch(
        `${UrlApi}/envasado_rendiciones/hayextendidas/${choferId}`,
      );
      const data = await response.json();

      // Si trae resultado (data.length > 0 o data tiene datos), bloquear
      if (data && data.length > 0) {
        setTieneExtendidas(true);
        return true;
      } else {
        setTieneExtendidas(false);
        return false;
      }
    } catch (error) {
      console.error("Error verificando rendiciones extendidas:", error);
      setTieneExtendidas(false);
      return false;
    } finally {
      setVerificandoExtendidas(false);
    }
  };

  useEffect(() => {
    if (choferSeleccionado && Object.keys(choferSeleccionado).length !== 0) {
      setIsLoading(true);
      try {
        obtenerRendicion();
        // Verificar si tiene rendiciones extendidas
        verificarRendicionesExtendidas(choferSeleccionado.id);
      } catch {
        console.error("Error");
      } finally {
        setIsLoading(false);
      }
    }
  }, [choferSeleccionado, repartoTarde, datos.fecha_para, esExtendida]);

  useEffect(() => {
    // Si es extendida, también mostrar advertencia si ya tiene  en el día
    if (esExtendida === 1) {
      // Para extendida: mostrar advertencia si ya tiene rendición normal o extendida en ese día
      if (
        rendicion.length > 0 &&
        Object.keys(choferSeleccionado).length !== 0
      ) {
        setMostrarAdvertencia(true);
      } else {
        setMostrarAdvertencia(false);
      }
    } else {
      // Validación normal: mostrar advertencia si ya tiene rendición
      if (
        rendicion.length > 0 &&
        Object.keys(choferSeleccionado).length !== 0
      ) {
        setMostrarAdvertencia(true);
      } else {
        setMostrarAdvertencia(false);
      }
    }
  }, [rendicion, choferSeleccionado, esExtendida]);

  const handleChangeChecked = (event) => {
    setChecked(event.target.checked);
  };

  // Verificar si el chofer tiene rendiciones_extendidas = 1
  useEffect(() => {
    if (choferSeleccionado && choferSeleccionado.rendiciones_extendidas === 1) {
      // Si tiene rendiciones_extendidas, mantenemos el estado actual de esExtendida
    } else {
      // Si no tiene rendiciones_extendidas, forzar esExtendida a 0
      setEsExtendida(0);
    }
  }, [choferSeleccionado]);

  const handleChangeExtendida = (event) => {
    setEsExtendida(event.target.checked ? 1 : 0);
  };

  const almacenar = async (e) => {
    const { name, value } = e.target;
    setDatos({
      ...datos,
      [name]: value,
    });

    // Verificar el número de rendición SOLO cuando tenga el formato completo
    if (name === "nro_rendicion") {
      // Validar formato: 5 dígitos + guión + 8 dígitos = 14 caracteres
      const formatoValido = /^\d{5}-\d{8}$/.test(value);

      if (formatoValido) {
        // Solo verificar si el formato es completo y válido
        await verificarNroRendicion(value);
      } else if (value && value.length > 0) {
        // Mostrar error de formato pero no verificar en la base de datos
        setNroRendicionValido(false);
        setNroRendicionMensaje("Formato inválido. Use: 12345-12345678");
      } else {
        // Campo vacío
        setNroRendicionValido(true);
        // setNroRendicionMensaje("El número de rendición es requerido");
      }
    }
  };

  async function guardarChoferAsignado(e) {
    setDisbtn(true);

    if (datos.nro_rendicion && datos.nro_rendicion.trim() !== "") {
      const esValido = await verificarNroRendicion(datos.nro_rendicion);

      if (!esValido) {
        setDisbtn(false);
        setNotificacion({
          open: true,
          mensaje:
            "El número de rendición ya existe o es inválido. Por favor, ingrese un número diferente.",
          severity: "error",
        });
        return;
      }
    }

    if (rendicion.length === 0) {
      try {
        await postData(
          e,
          "/envasado_rendiciones/",
          {
            fecha: moment(datos.fecha_para).format("YYYY-MM-DD"),
            chofer: choferSeleccionado.id,
            uuid: uuidRendicion,
            nro_rendicion: datos.nro_rendicion,
            estado: 272,
            hoja_ruta: hojaSeleccionada.id,
            usuario: localStorage.getItem("user"),
            activo: 1,
            es_extendida: esExtendida,
            sucursal:choferSeleccionado.id_sucursal
          },
          setNotificacion,
        );

        setNotificacion({
          open: true,
          mensaje: "Rendición asignada con éxito",
          severity: "success",
        });

        onClose(); // cerrar el modal
      } catch (error) {
        console.error(error);
        setNotificacion({
          open: true,
          mensaje: "Ocurrió un error al guardar",
          severity: "error",
        });
      }
    }
    setDisbtn(false);
  }
  

  const verificarNroRendicion = async (nro) => {
    // Validar formato completo antes de verificar
    const formatoValido = /^\d{5}-\d{8}$/.test(nro);

    if (!nro) {
      setNroRendicionValido(false);
      setNroRendicionMensaje("El número de rendición es requerido");
      return false;
    }

    if (!formatoValido) {
      setNroRendicionValido(false);
      setNroRendicionMensaje("Formato inválido. Use: 12345-12345678");
      return false;
    }

    setVerificandoNro(true);
    try {
      const response = await fetch(
        `${UrlApi}/envasado_rendiciones/verificar-nro/${nro}`,
      );
      const data = await response.json();

      if (data.exists) {
        setNroRendicionValido(false);
        setNroRendicionMensaje(
          `El número de rendición ${nro} ya existe. Por favor, ingrese un número diferente.`,
        );
        return false;
      } else {
        setNroRendicionValido(true);
        setNroRendicionMensaje("Número de rendición válido");
        return true;
      }
    } catch (error) {
      console.error("Error verificando número de rendición:", error);
      setNroRendicionValido(false);
      setNroRendicionMensaje("Error al verificar el número de rendición");
      return false;
    } finally {
      setVerificandoNro(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Crear Rendición
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent>
          <Grid container spacing={1}>
            {mostrarAdvertencia === true && esExtendida !== 1 ? (
              <Grid
                item
                xs={12}
                style={{
                  backgroundColor: "#fff9c4",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "8px",
                }}
              >
                <label>
                  El chofer {choferSeleccionado.nombre_apellido} ya tiene
                  asignada una rendición en el día{" "}
                  {moment(datos.fecha_para, "YYYY-MM-DD ").format("DD-MM-YYYY")}
                </label>
              </Grid>
            ) : null}

            {mostrarAdvertencia === true && esExtendida === 1 ? (
              <Grid
                item
                xs={12}
                style={{
                  backgroundColor: "#ffcccc",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "8px",
                  color: "#d32f2f",
                }}
              >
                <label>
                  El chofer {choferSeleccionado.nombre_apellido} ya tiene una
                  rendición en el día{" "}
                  {moment(datos.fecha_para, "YYYY-MM-DD ").format("DD-MM-YYYY")}
                  . No puede crear una rendición extendida.
                </label>
              </Grid>
            ) : null}

            {tieneExtendidas === true ? (
              <Grid
                item
                xs={12}
                style={{
                  backgroundColor: "#ffcccc",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "8px",
                  color: "#d32f2f",
                }}
              >
                <label>
                  El chofer {choferSeleccionado.nombre_apellido} tiene
                  rendiciones extendidas sin cerrar. No puede crear una nueva
                  rendición.
                </label>
              </Grid>
            ) : null}
            <Grid item xs={6}>
              <TextField
                fullWidth={true}
                focused
                size="small"
                type="date"
                required
                placeholder="Fecha "
                name="fecha_para"
                label="Fecha de Rendicion"
                variant="outlined"
                value={moment(datos.fecha_para).format("YYYY-MM-DD")}
                onChange={almacenar}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                disabled={!choferes}
                required
                disableClearable
                id="chofer"
                size="small"
                noOptionsText={"Chofer INEXISTENTE"}
                options={choferes}
                autoHighlight
                getOptionLabel={(chofer) =>
                  chofer.id + "-" + chofer.nombre_apellido
                }
                onChange={(event, value) => {
                  setChoferSeleccionado(value);
                  setIsLoading(true);
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    key={option.id}
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.id} - {option.nombre_apellido}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    placeholder="Tipee para buscar..."
                    {...params}
                    label="Chofer"
                    focused
                    required
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <InputMask
                mask="99999-99999999"
                disabled={false}
                maskChar=""
                value={datos.nro_rendicion}
                onChange={almacenar}
              >
                {() => (
                  <TextField
                    size={"small"}
                    style={style}
                    focused
                    type="text"
                    name="nro_rendicion"
                    label="Numero Rendición"
                    error={!nroRendicionValido}
                    helperText={nroRendicionMensaje}
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                disabled={!hojaRuta}
                required
                id="hoja"
                size="small"
                noOptionsText={"hoja de Ruta INEXISTENTE"}
                options={hojaRuta}
                autoHighlight
                getOptionLabel={(hoja) =>
                  hoja.patente + "-" + hoja.nombre + "-" + hoja.nombre_sucursal
                }
                onChange={(event, value) => {
                  setHojaSeleccionada(value);
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    key={option.id}
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.patente} - {option.nombre} -{" "}
                    {option.nombre_sucursal}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    placeholder="Tipee para buscar..."
                    {...params}
                    label="Hoja de Ruta"
                    focused
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
            {choferSeleccionado &&
              choferSeleccionado.rendiciones_extendidas === 1 && (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      backgroundColor: "#f0f7ff",
                      borderRadius: 2,
                      p: 1.5,
                      border: "1px solid #90caf9",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mt: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <AccessTimeIcon sx={{ color: "#1976d2", fontSize: 20 }} />
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, color: "#1565c0" }}
                      >
                        Rendición Extendida
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={esExtendida === 1}
                          onChange={handleChangeExtendida}
                          sx={{
                            color: "#1976d2",
                            "&.Mui-checked": {
                              color: "#1976d2",
                            },
                          }}
                        />
                      }
                      labelPlacement="start"
                      sx={{ mr: 0 }}
                    />
                  </Box>
                </Grid>
              )}
          </Grid>
          <Grid
            mt={1}
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button variant="contained" onClick={() => onClose()} color="error">
              Volver
            </Button>
            <Button
              disabled={
                isLoading ||
                (mostrarAdvertencia && esExtendida !== 1) || // Para no extendida, bloquear si hay advertencia
                (esExtendida === 1 &&
                  (mostrarAdvertencia || tieneExtendidas)) || // Para extendida, bloquear si hay advertencia O tiene extendidas
                !choferSeleccionado ||
                disbtn ||
                tieneExtendidas ||
                !nroRendicionValido ||
                verificandoNro ||
                verificandoExtendidas
              }
              variant="contained"
              onClick={guardarChoferAsignado}
              color="success"
            >
              Guardar
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={notificacion.open}
        autoHideDuration={3000}
        onClose={() => setNotificacion({ ...notificacion, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setNotificacion({ ...notificacion, open: false })}
          severity={notificacion.severity}
          sx={{ width: "100%" }}
        >
          {notificacion.mensaje}
        </Alert>
      </Snackbar>
    </>
  );
}

export default NuevaRendicion;
